import React from "react";

/*
 * Shared "no access / not purchased" message for Third-Party Accounts Receivable.
 *
 * Rendered in two situations:
 *  1. A parent company is resolved but its attributes indicate no access
 *     (ABID 99 present, or ABID 100 missing) — see Tpar.js.
 *  2. A group user selects a group/parent company that resolves to no
 *     accessible members, which would otherwise leave an empty parent-company
 *     dropdown ("NO DATA FOUND") — see ParentCompanySelectionForGroupUsers.js.
 */
export default function TparNoAccessMessage() {
    return (
        <div>
            <p>
                You have clicked on Third-Party Accounts Receivable.
            </p>
            <p>Either:
            </p>
            <p>
                1. Your reports are being auto generated and delivered to your personal sFTP folder for pickup.
            </p>
            <p>
                a. If additional assistance is required, please contact Net-Rx at customerservice@net-rx.com
            </p>
            <p>
                -OR-
            </p>
            <p>
                2. You have not purchased this product.
            </p>
            <p>
                a. To learn about the benefits of Third-Party Accounts Receivable, please contact Net-Rx at sales@net-rx.com
            </p>
        </div>
    );
}
